import axios from "axios";
import apiClient from './apiClient'; // Import the custom client
export const fetchAllWorkInstructions = async (cancelToken) => {
    try {
        // Use apiClient instead of axios
        const {data} = await apiClient.get(`/api/wip`, {cancelToken});
        return data;
    } catch (error) {
        throw error;
    }
};

export const fetchReleasedWorkInstructions = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/wip/released`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const createWipStep = async (step,stepToUpdate) => {
    try {
        let d = {step,stepToUpdate}
        let { data } = await axios.post(`/api/wip/createStep`,d)
        return data
        
    } catch (error) {
        throw error
    }
};

export const deleteWipStep = (step) => {
    try {
        return axios.post(`/api/wip/deleteStep`,step)
        
    } catch (error) {
        throw error
    }
};

export const deleteHighlight = (highlight) => {
    try {
        console.log("RE-RUN?")
        return axios.post(`/api/wip/deleteHighlight`, highlight)
        
    } catch (error) {
        throw error
    }
};

export const createModelAnnotation = (anno) => {
    try {
        return axios.post(`/api/wip/annotation`, anno)
        
    } catch (error) {
        throw error
    }
};

export const deleteModelAnnotation = (id) => {
    try {
        return axios.delete(`/api/wip/deleteModelAnnotation/${id}`)
        
    } catch (error) {
        throw error
    }
};

export const deleteAttachmentInUse = (aiu) => {
    try {
        return axios.post(`/api/wip/deleteAttachmentInUse`, aiu)
        
    } catch (error) {
        throw error
    }
};

export const createAttachmentInUse = (aiu) => {
    try {
        return axios.post(`/api/wip/createAttachmentInUse`, aiu)
    } catch (e) {
        throw e
    }
}

export const deleteWipGroup = (wipgroup) => {
    try {
        return axios.post(`/api/wip/deleteWipGroup`, wipgroup)
        
    } catch (error) {
        throw error
    }
};

export const createHighlight = async (highlight) => {
    try {
        return axios.post(`/api/wip/createHighlight`, highlight)
    } catch (e) {
        throw e
    }
}

export const createWorkInstruction = (workInstructionPayload,attachment,clone)=> {
    let data = {wi: workInstructionPayload,attachment:attachment,clone:clone}
    return axios.post(`/api/wip`, data)
}

export const convertPDF = (file, cb) => {
    return axios.post(`/api/wip/pdf-upload`, file, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => cb(progressEvent),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
    })
}

export const uploadPDF = (file, cb) => {
    return axios.post(`/api/wip/pdf-upload-noconvert`, file, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
        onUploadProgress: (progressEvent) => cb(progressEvent),
        maxContentLength: Infinity,
        maxBodyLength: Infinity
    })
}

export const fetchWorkInstruction = (WIID, isForEditing = false) => {
    // Use apiClient instead of axios
    const params = isForEditing ? { editing: 'true' } : {};
    return apiClient.get(`/api/wip/${WIID}`, { params });
};

export const updateWorkInstruction = updatedWorkInstruction => {
    return axios.patch(`/api/wip/${updatedWorkInstruction._id}`, updatedWorkInstruction)
}

export const deleteWorkInstruction = WIID => {
    return axios.delete(`/api/wip/${WIID}`)
}

export const cloneWorkInstruction = WIID => {
    return axios.post(`/api/wip/${WIID}/clone`)
}

export const checkNameAvailability = name => {
    let url = encodeURIComponent(name);
    return axios.get(`/api/wip/check-availability/${url}`)
}

export const  generateAIWorkInstructionCall = async (prompt) => {
     const headers = {
         "Content-Type": "application/json",
         };
        
         const data = {
         text: prompt,
         };
         
         return axios.post("/api/wip/ai_prompt",data,{headers})
}
